module.exports = __webpack_public_path__ + "static/media/NSA.e51fc339.pdf";